// extracted by mini-css-extract-plugin
export default {"actions":"TermsOfServiceModal_actions__cuRXa"};